export const SOCIAL_LINKS = {
    linkedin: 'https://ng.linkedin.com/company/tmbis-ng-trs',
    whatsapp: 'http://surl.li/mumpei',
    instagram: 'https://www.instagram.com/thronemanagementand_business/',
    facebook: 'https://web.facebook.com/thronemanagement',
};

export const ADVISOR_URL = SOCIAL_LINKS.whatsapp;

export const CONTACT = {
    email: 'info@thronebusinessinstituteswitzerland.com',
    phone: '+2349134942707',
    phoneDisplay: '+234 913 494 2707',
    address: 'Via Vigizzi 98, Unterlangenegg 3614, Switzerland',
};
